import { render, staticRenderFns } from "./BadgeFeedUpdate.vue?vue&type=template&id=3da24658"
import script from "./BadgeFeedUpdate.vue?vue&type=script&lang=js"
export * from "./BadgeFeedUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports